import { all } from "redux-saga/effects";
import authWatcher from "./modules/auth/watcher";
import categoryWatcher from "./modules/category/watcher";
import courseWatcher from "./modules/course/watcher";
import intructorCourseWatcher from "./modules/instructorCourse/watcher";
import ordersWatcher from "./modules/orders/watcher";
import userWatcher from "./modules/user/watcher";
import courseLevelWatcher from "./modules/courseLevel/watcher";
import audioLanguageWatcher from "./modules/audioLanguage/watcher";
import closeCaptionWatcher from "./modules/closeCaption/watcher";
import enrollmentWatcher from "./modules/enrollment/watcher";
import subscriptionWatcher from "./modules/subscription/watcher";
import reviewWatcher from "./modules/review/watcher";
import uploadWatcher from "./modules/upload/watcher";
import balanceWatcher from "./modules/balance/watcher";

export default function* rootSaga() {
  yield all([
    ...categoryWatcher,
    ...authWatcher,
    ...courseWatcher,
    ...intructorCourseWatcher,
    ...userWatcher,
    ...ordersWatcher,
    ...courseLevelWatcher,
    ...audioLanguageWatcher,
    ...closeCaptionWatcher,
    ...enrollmentWatcher,
    ...subscriptionWatcher,
    ...reviewWatcher,
    ...uploadWatcher,
    ...balanceWatcher,
  ]);
}
